"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

const shared = `
  margin: 0 4px;
`;
const StyledArrowPointUp = (0, _styledComponents.default)(_blocks.ArrowPointUp)`
  ${shared};
`;
const StyledArrowPointDown = (0, _styledComponents.default)(_blocks.ArrowPointDown)`
  ${shared};
`;

const SortArrow = ({
  direction = 'desc'
}) => {
  if (direction === 'asc') {
    return /*#__PURE__*/_react.default.createElement(StyledArrowPointUp, {
      tiny: true
    });
  }

  return /*#__PURE__*/_react.default.createElement(StyledArrowPointDown, {
    tiny: true
  });
};

var _default = SortArrow;
exports.default = _default;
module.exports = exports.default;